import { RefMap, approach } from 'src/util';

import Player from './Player';

type AnimatedRatings = RefMap<Player, number>;

function AnimatedRatings() {
  return RefMap<Player, number>();
}

namespace AnimatedRatings {
  export type Action = {
    dt: number,
    target: AnimatedRatings,
  };

  export function reduce(
    ar: AnimatedRatings,
    action: Action,
  ): AnimatedRatings {
    return RefMap.map(action.target, (newRating, playerRef) => {
      const oldRating = RefMap.get(ar, playerRef) || 0;

      return approach({
        value: oldRating,
        target: newRating,
        dt: action.dt,
        decayPeriod: 200,
        epsilon: 0.000001,
      });
    });
  }
}

export default AnimatedRatings;



// WEBPACK FOOTER //
// ./src/state/AnimatedRatings.ts